// extracted by mini-css-extract-plugin
var _1 = "Carousel__arrowContainer--w8PQu";
var _2 = "Carousel__arrows--lYFF7";
var _3 = "Carousel__main--yjYdC";
var _4 = "Carousel__mainContainer--BGB5E";
var _5 = "Carousel__pageContainer--PWLfz";
var _6 = "Carousel__pageInnerContainer--U7DsS";
var _7 = "Carousel__tempContainer--FmH_3";
export { _1 as "arrowContainer", _2 as "arrows", _3 as "main", _4 as "mainContainer", _5 as "pageContainer", _6 as "pageInnerContainer", _7 as "tempContainer" }
